import List from './list';

export default class MessageList extends List {
  mapItem = (item) => {
    item.own = item.from === this.userId;
    item.isRemoved = item.removed && item.removed.indexOf(this.userId) !== -1;
    if (!item.counter) item.counter = parseInt(item.id.toString().split('_')[1]);
    if (item.media?.length > 0) {
      item.imagesUri = item.media
        .filter((media) => media.fileType === 'image' && media.uri)
        .map((media) => media.uri);
    }
    item.textOrigin = item.text;
    return item;
  };

  onMessage = ({ channel, data: msgData }) => {
    let data = { ...msgData };
    let userId = this.userId;
    if (channel !== 'u-' + userId) return this.log('wrong channel');
    if (!this.filterItem(data)) return this.log('filtered');
    let { id, counter, tempId, from, to } = data;
    let listId = 'recent';

    this.log('onMessage', { from, to, id, tempId });
    let items = this.items(listId);
    var exist = false;
    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      if (
        item.state &&
        ((item.tempId && item.tempId === tempId) || (item.id && item.id === id)) &&
        item.from === from &&
        from === userId
      ) {
        exist = true;
        if (item.state === 'sending') {
          item.state = 'sent';
          item.id = id;
          item.counter = counter;
          item.updated = Date.now();
          if (data.media && data.media.length > 0) {
            item.media = data.media.map((media, index) => {
              return {
                ...media,
                uri: item.media[index].uri
              };
            });
            this.setStateSilent({
              itemUpdated: Date.now()
            });
          }
          this.log('sent message updated by socket', item);
        } else {
          this.log('sent message found but already settled, ignoring by socket');
        }
        break;
      } else if (item.id === id) {
        exist = true;
        this.log('socket message duplicated');
        break;
      }
    }
    if (!exist) {
      this.log('socket message not found, adding');
      // delete data.tempId;
      data.own = data.from === userId;

      items.unshift(this.mapItem(data, -1, items));
      this.setListState({ items }, listId);
    }
  };

  onMessageUpdateWS = ({ data }) => this.onMessageUpdate(data);
  onMessageUpdate = (data) => {
    this.updateItem(data, { listId: 'recent' });
    this.updateItem(data, { listId: 'search' });
  };

  filterItem = () => true;

  onFilterOtherItem = (data) => {
    data = this.mapItem(data);
    let listId = 'recent';

    let items = this.items(listId);
    let index = items.findIndex((item) => item.id === data.id);
    if (data.removedDate) {
      if (index > -1) items.splice(index, 1);
    } else {
      if (index < 0) items.unshift(data);
      else items[index] = { ...items[index], ...data };
    }
    this.setListState({ items: this.sortBy ? this.sort(items, this.sortBy) : items }, listId);

    return false;
  };
}
